<div class="row justify-content-center">
    <div class="col-auto">
        <div class="section-header mb-4 d-flex text-center justify-content-center gap-2" style="max-width: 520px;">
            <span class="material-symbols-outlined">account_balance</span>
            <h1 class="h4">Gestión de <strong class="fw-semibold text-colonial">Bancos</strong></h1>
        </div>
        <p class="text-muted mx-auto text-center" style="max-width: 520px;">Visualiza, crea, edita y elimina bancos y
            sus sucursales.</p>
    </div>
</div>

<div class="row justify-content-center">
    <div class="col-12 col-xl-10">
        <div class="card shadow-sm border-0 overflow-hidden rounded-4">
            <div class="card-header bg-white py-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
                <h3 class="h5 mb-0 d-flex gap-2 align-items-center">
                    <span class="material-symbols-outlined text-colonial">list</span>
                    <span>Bancos</span>
                </h3>
                <div class="d-flex align-items-center gap-3" *ngIf="isSuperUser">
                    <button (click)="navigateToCreate()"
                        class="btn bg-colonial btn-secondary d-flex align-items-center gap-1" type="button">
                        <span class="material-symbols-outlined" style="font-size: 18px;">add</span>
                        Nuevo
                    </button>
                </div>
            </div>
            <shared-table-container>
                <shared-table [headers]="tableHeaders" [items]="filteredBanks" (endSearching)="onSearch($event)"
                    searchPlaceholder="Buscar bancos" title="Bancos">
                    <ng-template let-id="id" sharedTableColumn="actions">
                        <div class="d-flex gap-2">
                            <button (click)="$event.stopPropagation(); navigateToEdit(id)"
                                class="btn btn-sm btn-outline-secondary" type="button">
                                <span class="material-symbols-outlined" style="font-size: 18px;">edit</span>
                            </button>
                            <button *ngIf="isSuperUser" (click)="$event.stopPropagation(); deleteBank(id)"
                                class="btn btn-sm btn-outline-danger" type="button">
                                <span class="material-symbols-outlined" style="font-size: 18px;">delete</span>
                            </button>
                        </div>
                    </ng-template>
                </shared-table>
            </shared-table-container>
        </div>
    </div>
</div>